// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-container {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
    font-family: 'Inter', sans-serif;
  }
  
  .feedback-container h2 {
    font-size: 1.8rem;
    color: #0047AB;
    margin-bottom: 20px;
  }
  
  .feedback-container p {
    font-size: 1rem;
    color: #333;
    margin-bottom: 10px;
  }
  
  .feedback-container pre {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #ddd;
    white-space: pre-wrap; /* Allows the text to wrap */
    word-wrap: break-word; /* Prevents long words from breaking the layout */
    font-size: 1rem;
    color: #333;
  }
  
  .feedback-container button {
    padding: 10px 20px;
    background-color: #0047AB;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .feedback-container button:hover {
    background-color: #003080;
  }
  
  .error-message {
    color: #D8000C;
    background-color: #FFBABA;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  
  .feedback-text {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #ddd;
    white-space: pre-wrap; /* Allows the text to wrap */
    word-wrap: break-word; /* Prevents long words from breaking the layout */
    font-size: 1rem;
    color: #333;
  }`, "",{"version":3,"sources":["webpack://./src/components/Feedback.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB,EAAE,4BAA4B;IACnD,qBAAqB,EAAE,iDAAiD;IACxE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB,EAAE,4BAA4B;IACnD,qBAAqB,EAAE,iDAAiD;IACxE,eAAe;IACf,WAAW;EACb","sourcesContent":[".feedback-container {\n    padding: 20px;\n    max-width: 800px;\n    margin: 0 auto;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .feedback-container h2 {\n    font-size: 1.8rem;\n    color: #0047AB;\n    margin-bottom: 20px;\n  }\n  \n  .feedback-container p {\n    font-size: 1rem;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  .feedback-container pre {\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n    white-space: pre-wrap; /* Allows the text to wrap */\n    word-wrap: break-word; /* Prevents long words from breaking the layout */\n    font-size: 1rem;\n    color: #333;\n  }\n  \n  .feedback-container button {\n    padding: 10px 20px;\n    background-color: #0047AB;\n    color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .feedback-container button:hover {\n    background-color: #003080;\n  }\n  \n  .error-message {\n    color: #D8000C;\n    background-color: #FFBABA;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .feedback-text {\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n    white-space: pre-wrap; /* Allows the text to wrap */\n    word-wrap: break-word; /* Prevents long words from breaking the layout */\n    font-size: 1rem;\n    color: #333;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
